import { useRef } from 'react';
import { useState, useEffect, useCallback } from 'react';
import ArtworkGallery from '../components/ArtworkGallery';
import ErrorPage from '../components/ErrorPage';
import LoadingIndicator from '../components/LoadingIndicator';
import '../App.css';

export default function Artwork() {
    const sliderRef = useRef(null);
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (isLoading) {
                setHasError(true);
                setIsLoading(false);
            }
        }, 25000);

        return () => clearTimeout(timeout);
    }, [isLoading]);

    const handleAllImagesLoaded = useCallback(() => {
        setIsLoading(false);
    }, []);

    const handleError = useCallback((error) => {
        setHasError(true);
        setIsLoading(false);
    }, []);

    if (hasError) {
        return <ErrorPage msg='Server Error' />;
    }

    return (
        <div className='artwork-container'>
            {
                isLoading && <LoadingIndicator />
            }
            <div style={{ display: isLoading ? 'none' : 'block' }}>
                <div className='slider' ref={sliderRef}>
                    <ArtworkGallery
                        isSlider={true}      
                        onAllImagesLoaded={handleAllImagesLoaded}
                        onError={handleError}
                    />
                </div>
            </div>    
        </div>
    );
}